import Database from 'database';

export const Types = {
  GET_ESTADOS: 'estados/GET_ESTADOS',
  GET_ESTADOS_SUCCESS: 'estados/GET_ESTADOS_SUCCESS',
  GET_ESTADOS_FAILED: 'estados/GET_ESTADOS_FAILED',
};

const initialState = {
  loading: false,
  error: null,
  data: [],
};

export default function estadosReducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_ESTADOS:
      return { ...state, loading: true };
    case Types.GET_ESTADOS_SUCCESS:
      return { ...state, loading: false, data: [...action.payload.data] };
    case Types.GET_ESTADOS_FAILED:
      return { ...state, loading: false, error: action.payload.error };
    default:
      return state;
  }
}

export const Creators = {
  getEstados: () => async dispatch => {
    try {
      dispatch({ type: Types.GET_ESTADOS });
      const estados = await Database.estados.toArray();
      dispatch({ type: Types.GET_ESTADOS_SUCCESS, payload: { data: estados } });
    } catch (woof) {
      console.error(woof.message);
      dispatch({
        type: Types.GET_ESTADOS_FAILED,
        payload: { error: 'Serviço indisponível' },
      });
    }
  },
};
